const VERSION_KEY = 'app:cache_version'
const urlsToCache = []

const PREFIX = 'nav_footer_cache'

export function getDataVersion() {
  try {
    return localStorage.getItem(VERSION_KEY) || ''
  } catch {
    return ''
  }
}

export function keyFor(url) {
  const v = getDataVersion() || 'no-ver'
  return `${PREFIX}:${v}:${url}`
}

/**
 * Fetches version, compares to localStorage, clears sessionStorage if changed,
 * then stores the new version. Returns { changed, version }.
 */
export async function refreshDataVersion(endpoint) {
  if (!urlsToCache.includes(endpoint)) {
    urlsToCache.push(keyFor(endpoint))
  }
  let prev = null
  try {
    prev = localStorage.getItem(VERSION_KEY) || null
  } catch (e) {
    console.warn(e)
  }

  let next = prev
  try {
    const res = await fetch(endpoint, { method: 'GET', credentials: 'include' })
    if (!res.ok) throw new Error(`Version fetch failed: ${res.status}`)
    const payload = await res.json()
    next = String(payload?.bundles?.default?.version ?? '')
  } catch (err) {
    console.warn('[version] Could not refresh data version:', err)
    // If we cannot fetch version, keep prior value and do not clear caches
    return { changed: false, version: prev ?? '' }
  }

  const changed = !!next && next !== prev
  // If version changed, clear all sessionStorage entries before writing new version
  if (changed) {
    try {
      for (let key of urlsToCache) {
        sessionStorage.removeItem(key)
      }
    } catch (e) {
      console.warn('[version] sessionStorage.clear() failed:', e)
    }
  }

  // Store updated version (even if unchanged, we refresh the persisted value)
  try {
    if (next) localStorage.setItem(VERSION_KEY, next)
  } catch (e) {
    console.warn(e)
  }

  return { changed, version: next ?? '' }
}
